import React from 'react'
import { Route, Switch } from 'react-router-dom'
import NoticeList from '@/pages/notification/notice-list/notice-list'
import NormalNoticeDetail from '@/pages/notification/normal-notice-detail/normal-notice-detail'
import AuditNoticeDetail from '@/pages/notification/audit-notice-detail/audit-notice-detail'
import ContractDetails from '@/pages/notification/contract-details/contract-details'
import DismissOpinion from '@/pages/notification/dismiss-opinion/dismiss-opinion'

function Notification({match}:any) {
  return (
    <Switch>
        <Route exact path={`${match.path}/list`}  component={NoticeList} />
        <Route exact path={`${match.path}/normal-detail/:type/:id`} component={NormalNoticeDetail} />
        <Route exact path={`${match.path}/audit-detail/:type/:id`} component={AuditNoticeDetail} />
        <Route exact path={`${match.path}/contract-details/:id`} component={ContractDetails} />
        <Route exact path={`${match.path}/dismiss-opinion`} component={DismissOpinion} />
    </Switch>
  )
}

export default Notification

